<script lang="ts">
	import { cn } from '$lib/utils';

	let className = '';
	export { className as class };
</script>

<svg
	class={cn('h-28 w-auto fill-lightTertiary', className)}
	width="136"
	height="91"
	viewBox="0 0 136 91"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		id="Union"
		opacity="0.1"
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M52.681 16.0646L83.2928 7.86224C108.389 1.13784 120.936 -2.22435 131.5 1.62042C135.408 3.04289 139.037 5.13818 142.223 7.81153C150.835 15.0374 154.197 27.5852 160.921 52.681C167.646 77.7768 171.008 90.3247 167.163 100.888C165.741 104.796 163.645 108.425 160.972 111.611C154.121 119.776 142.485 123.222 119.905 129.289C120.086 129.962 120.15 130.678 120.078 131.413C119.266 139.643 122.889 148.256 128.517 152.656L129.456 153.389L145.726 149.03C148.896 148.18 152.154 150.062 153.003 153.232C153.853 156.402 151.972 159.66 148.802 160.509L129.737 165.618C129.695 165.629 129.653 165.641 129.611 165.652L91.463 175.873C91.4213 175.885 91.3794 175.896 91.3374 175.907L72.2722 181.015C69.1023 181.865 65.8439 179.984 64.9946 176.814C64.1452 173.644 66.0264 170.385 69.1963 169.536L85.4662 165.176L85.9122 164.072C88.5871 157.447 87.4182 148.177 82.5993 141.455C82.1694 140.855 81.8672 140.203 81.6871 139.53C59.0991 145.566 47.2993 148.399 37.2835 144.754C33.3754 143.331 29.7462 141.236 26.5602 138.563C17.9488 131.337 14.5866 118.789 7.86224 93.6931C1.13784 68.5973 -2.22435 56.0494 1.62043 45.4859C3.04289 41.5778 5.13818 37.9486 7.81153 34.7626C15.0374 26.1512 27.5852 22.789 52.681 16.0646ZM98.8107 161.601L116.111 156.965C110.73 150.246 107.795 141.229 108.104 132.453L93.4893 136.369C98.145 143.814 100.112 153.091 98.8107 161.601ZM85.4538 107.763C82.2838 108.612 80.4026 111.87 81.252 115.04C82.1014 118.21 85.3597 120.091 88.5297 119.242L103.836 115.141C107.006 114.291 108.887 111.033 108.037 107.863C107.188 104.693 103.93 102.812 100.76 103.661L85.4538 107.763Z"
	/>
</svg>
